import { ShoppingCart, ShoppingCartPlanInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from 'shared/services/axios';
import { mapRestCartToGqlCart, RestShoppingCart } from './upsertCartAddonsRest';

export async function upsertCartPlanRest(input: ShoppingCartPlanInput): Promise<ShoppingCart> {
  const response = await api.post<RestShoppingCart>(apiEndpoints.upsertCartPlan, input);
  return mapRestCartToGqlCart(response.data);
}
